import { createAsyncThunk } from '@reduxjs/toolkit';
import { makeRequest } from 'Douleutaras/services/apiClient';
import { StatsRequestProps } from 'Douleutaras/redux/data/stats/types';

const STATS_PERFORMANCE_API = 'api/public/v3/stats/performance';

export interface PerformanceDateRange {
  date_from: string;
  date_to: string;
  rule: 'days' | 'weeks' | 'months' | 'quarters';
}

export interface PerformanceUserAvg {
  user: number;
  avg: number;
}

export interface StatsPerformance {
  date_ranges: Array<PerformanceDateRange>;
  jobs_assigned: Array<PerformanceUserAvg>;
  revenue_assigned: Array<PerformanceUserAvg>;
  revenue_assigned_job: Array<PerformanceUserAvg>;
  quote_rate: Array<PerformanceUserAvg>;
  fulfillment_rate: Array<PerformanceUserAvg>;
  response_time: Array<PerformanceUserAvg>;
  revenue_concluded: string;
}

const performanceCacheMap: Map<string, StatsPerformance> = new Map();

export const getStatsPerformance = createAsyncThunk<StatsPerformance, StatsRequestProps>(
  'stats/performance/get',
  async ({ catId, subCatId, from, to }, api) => {
    const request = `${STATS_PERFORMANCE_API}/${catId}/${subCatId}/${from}/${to}/`;
    if (!performanceCacheMap.has(request)) {
      const response = await makeRequest(
        request,
        {
          method: 'GET'
        }
      )(api);
      performanceCacheMap.set(request, response.data.data);

      return response.data.data;
    } else {
      return performanceCacheMap.get(request);
    }
  }
);
